import styled, { css } from 'styled-components';

type props = {
  active?: boolean
}

export const PolicemanMarkerWrapper = styled.div<props>`
  display: flex;
  flex-direction: column;
  background-color: var(--black-200);
  border-radius: 6px;
  margin-bottom: 10px;
  border: 2px solid transparent;

  ${({active}) => active && css`
    border: 2px dashed var(--primary);
  `}

`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.75rem;
`

export const HeaderBody = styled.div`
  display: flex;
  flex-direction: row;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: var(--black-400);
  border-radius: 4px;
  svg {
    width: 26px;
    height: 26px;
    path {
      stroke: var(--primary);
    }
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 0.8rem;
  h4:last-of-type {
    color: var(--primary);
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`

export const HeaderFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.9rem;
  font-family: Inter, sans-serif;
`

type propsBadge = {
  work?: boolean
}

export const HeaderBadge = styled.div<propsBadge>`
  width: 100%;
  padding: 0.5625rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.8rem;
  font-family: DM Sans;
  min-height: 2rem;
  justify-content: center;
  color: var(--orange);
  background-color: var(--black-400);

  ${({work}) => work && css`
    color: var(--green);
  ` }
`

export const OccurrenceMarkerBody = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0rem 0.75rem 0.75rem;
`

export const Button = styled.button`
  height: 35px;
  width: 100%;
  margin-right: 0.5rem;
  font-family: Inter, sans-serif;
  font-size: 0.9rem;
  border-radius: 4px;
  background-color: var(--black-400);
  color: var(--white);
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.8;
  }

  &:last-child {
    margin-right: 0rem;
  }
`

type propsButton = {
  active?: boolean
}

export const FavoriteButton = styled.button<propsButton>`
  width: 50px;
  background-color: var(--black-100);
  border: 1px dashed transparent;

  ${({active}) => active && css`
  border-color: var(--primary);

  svg {
    fill: var(--primary);
    path {
      stroke: var(--primary);
      fill: var(--primary);
    }
  }
  `}
`